import { useState, useContext, createContext, useEffect } from "react";
import axios from "axios";


const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({
    user: null,
    token: "",
  });

  //deafult axios
  axios.defaults.headers.common["Authorization"] = auth?.token;
  
  useEffect(() => {
    const data = localStorage.getItem("auth");
    if (data) {
      const parseData = JSON.parse(data);
      setAuth((prev) => ({
        ...prev,
        user: parseData.user,
        token: parseData.token,
      }));
    }
  }, []);
  return (
    <AuthContext.Provider value={[auth, setAuth]}>
      {children}
    </AuthContext.Provider>
  );
};

//custom h0ook
const useAuth = () =>  useContext(AuthContext); 

export { AuthProvider, useAuth };